var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "roleTreeBox" },
    [
      _c("el-input", {
        attrs: { placeholder: "搜索", "prefix-icon": "el-icon-search" },
        model: {
          value: _vm.filterText,
          callback: function ($$v) {
            _vm.filterText = $$v
          },
          expression: "filterText",
        },
      }),
      _c(
        "div",
        { staticClass: "roleTreeC" },
        [
          _c(
            "dsf-virtual-scroll",
            { staticClass: "roleTree", attrs: { "scroll-x": "" } },
            [
              _c("el-tree", {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.loading,
                    expression: "loading",
                  },
                ],
                ref: "tree",
                attrs: {
                  "show-checkbox": "",
                  "default-expand-all": "",
                  "check-on-click-node": "",
                  "expand-on-click-node": false,
                  data: _vm.treeData,
                  "node-key": _vm.nodeKey,
                  props: _vm.defaultProps,
                  "empty-text": _vm.loading ? "" : "暂无数据",
                  "filter-node-method": _vm.filterNode,
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function (ref) {
                        var node = ref.node
                        return _vm._t("default", function () {
                          return [
                            _c("span", [
                              _c("i", {
                                staticClass:
                                  "myIcon iconfont icon-zhuhutiaocha",
                              }),
                              _vm._v(" " + _vm._s(node.label) + " "),
                            ]),
                          ]
                        })
                      },
                    },
                  ],
                  null,
                  true
                ),
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }